import React, { Fragment, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Button from "../../components/button";
import Label from "../../components/label";
import PropTypes from "prop-types";
import ICTimeInput from "../../components/form/timeInput";
import moment from "moment";
import DropdownMultiCheckbox from "../../components/form/dropDownWithCheckbox";
import MultipleDatePicker from "../../components/form/multipleDatePicker";
import ICSelect from "../../components/form/selectInput";
import CustomModal from "../../components/modal";
import { doctorInSchedule } from "../../utils/common";
import momentTz from "moment-timezone";

export const FilterAndProps = [{
  title: "Instant Switch", value: "Smoking Cessation", filter: doctor => {
    return !!doctor.authPrescriberSchemaNoMC;
  }, dataToSend: {
    shiftFor: "INSTANT_SWITCH"
  }
},{
  title: "Instant Leaf", value: "Medicinal Cannabis", filter: doctor => {
    return !!doctor.authPrescriberSchemaNoMC;
  }, dataToSend: {
    shiftFor: "INSTANT_LEAF"
  }
},  {
  title: "Instant Hush", value: "Instant Hush", filter: doctor => {
    return !!doctor.accessGranted?.isInstantHushAccessGranted;
  }, dataToSend: {
    shiftFor: "INSTANT_HUSH"
  }
}];

const AddShiftForm = props => {

  const getCurrentTimeInUTC = () => {
    // Get current time in UTC
    return moment().utc().toISOString();
  };
  
  const addHoursToUTC = (utcTime, hours) => {
    const date = new Date(utcTime);
    date.setHours(date.getHours() + hours);
    return date.toISOString();
  };

  const convertToUTC = (localTime) => {
    // Check if input is valid
    if (!localTime || !localTime.isValid()) {
      return moment().utc().toISOString(); // Get current UTC time if invalid
    }
  
    // Convert the given time to UTC
    return localTime.clone().utc().toISOString();
  };

  const formik = useFormik({
    initialValues: {
      doctorId: props.dataToEdit?.doctorId || props.doctorList[0]._id,
      shiftDates: props.dataToEdit ? props.selectedDay?.toISOString() : [props.selectedDay?.toISOString()].filter(date => !!date),
      shiftStartTime: props.dataToEdit ? moment(props.dataToEdit.shiftStartTime) : getCurrentTimeInUTC(),
      shiftEndTime: props.dataToEdit ? moment(props.dataToEdit.shiftEndTime) : addHoursToUTC(getCurrentTimeInUTC(), 9),
    }, validationSchema: Yup.object({
      doctorId: Yup.string().required("This field is required"),
      shiftDates: !props.dataToEdit ?
        Yup.array().of(Yup.string()).min(1).required("This field is required") :
        Yup.string().required("This field is required"),
      shiftStartTime: Yup.string().required("This field is required"),
      shiftEndTime: Yup.string().required("This field is required")
    }),
    onSubmit: values => {
      if (props.dataToEdit) {
        values["shiftId"] = props.dataToEdit._id;
      }

      if (moment(values.shiftStartTime).isAfter(moment(values.shiftEndTime))) {
        setModalErrorText("The start time must be before the end time");
        return;
      }

      props.onFormSubmit({ ...values, scheduleFilter });
    }
  });
  const [modalErrorText, setModalErrorText] = useState("");
  const [modalErrorTextStartTime, setModalErrorTextStatTime] = useState("");
  const [modalErrorTextEndTime, setModalErrorTextEndTime] = useState("");
  const [scheduleFilter, setScheduleFilter] = useState(getScheduleFilterDefault());
  console.log("scheduleFilter: ", scheduleFilter);

  function getDataToSend() {
    const scheduleDataToSend = {
      isInstantSwitchMC: false,
      isInstantSwitch: false,
      isInstantHush: false
    };

    for (const item of scheduleFilter) {
      if (item.title === "Instant Leaf") {
        scheduleDataToSend.isInstantSwitchMC = true;
      } else if (item.title === "Instant Switch") {
        scheduleDataToSend.isInstantSwitch = true;
      } else if (item.title === "Instant Hush") {
        scheduleDataToSend.isInstantHush = true;
      }
    }

    return scheduleDataToSend;
  }

  function getScheduleFilterDefault() {

    let scheduleFilters = '';

    if (props.dataToEdit) {
      for (const item of FilterAndProps) {
        if (item.title.includes("Switch") && props.dataToEdit.shiftFor === "INSTANT_SWITCH") {
          scheduleFilters = item;
        } else if (item.title.includes("Leaf") && props.dataToEdit.shiftFor === "INSTANT_LEAF") {
          scheduleFilters = item;
        } else if (item.title.includes("Hush") && props.dataToEdit.shiftFor === "INSTANT_HUSH") {
          scheduleFilters = item;
        }
      }
    }

    return scheduleFilters;
  }

  return (<>
    <form onSubmit={formik.handleSubmit} className="patient-notification-form row text-left">
      <div className="row col-sm-12 mt-2">
        <div className="col-sm-6">
          <Label
            title="Shift Date"
            className="font-15 gray w-100"
            required={true}
          />
          <MultipleDatePicker
            single={!!props.dataToEdit}
            error={!!(formik.touched.shiftDates && formik.errors.shiftDates)}
            defaultValue={formik.values.shiftDates}
            className="red"
            setDates={val => {
              formik.setFieldValue("shiftDates", val);
              formik.handleChange("shiftDates");
            }}
          />
        </div>

        <div className="col-sm-6 col">
          <p className="w-100 mx-3 mb-0 gray">Schedule</p>
          <DropdownMultiCheckbox
            disabled={!!props.dataToEdit}
            isMultiple={false}
            className="w-100 mx-3 mt-2"
            placeholder=""
            disableGrouping={true}
            onChange={setScheduleFilter}
            value={scheduleFilter}
            optionList={FilterAndProps.filter(filter => doctorInSchedule(props.doctorList[0], filter))}
          />
        </div>
      </div>
      <div className="col-sm-6 mt-3">
        <Label
          title="Shift Start Time"
          className="font-15 gray"
          required={true}
        />
        <ICTimeInput
          id="shiftStartTime"
          name="shiftStartTime"
          handleChange={val => {
            const utcTime = convertToUTC(val);
            formik.values.shiftStartTime = utcTime;
            // formik.values.shiftStartTime = val;
            // let valC = momentTz(val).format("YYYY-MM-DD HH:mm");
            // let newValue = momentTz.tz(valC, Intl.DateTimeFormat().resolvedOptions().timeZone).tz('Australia/Brisbane');
            // if (newValue.hour() < 6){
            //   // const defaultTime = val.set({ hour: 6, minute: 0 }); // Set time to 6:00 AM
            //   formik.values.shiftStartTime = null;
            //   setModalErrorTextStatTime("Shift start time must be between 6:00 AM and 12:00 AM AEST");
            // } else {
            //   formik.values.shiftStartTime = val;
            //   setModalErrorTextStatTime("")
            // }
          }}
          onBlur={formik.handleBlur}
          value={formik.values.shiftStartTime}
          defaultTime={formik.values.shiftStartTime}
          error={!!(formik.touched.shiftStartTime && formik.errors.shiftStartTime)}
          helperText={formik.touched.shiftStartTime && formik.errors.shiftStartTime ? formik.errors.shiftStartTime : ""}
        />
        {modalErrorTextStartTime && modalErrorTextStartTime !== "" && (<Label title={modalErrorTextStartTime} className="small error" />)}
        {formik.errors.shiftStartTime && formik.touched.shiftStartTime ? (
          <Label title="Please select shift start time" className="small error" />) : ("")}
        <p className="w-100 mb-0 gray">Brisbane Time</p>
      </div>
      <div className="col-sm-6 mt-3">
        <Label
          title="Shift End time"
          className="font-15 gray"
          required={true}
        />
        <ICTimeInput
          id="shiftEndTime"
          name="shiftEndTime"
          handleChange={val => {
            const utcTime = convertToUTC(val);
            formik.values.shiftEndTime = utcTime;
            // formik.values.shiftEndTime = val;
            // let valC = momentTz(val).format("YYYY-MM-DD HH:mm");
            // let newValue = momentTz.tz(valC, Intl.DateTimeFormat().resolvedOptions().timeZone).tz('Australia/Brisbane');
            // if (newValue.hour() < 6) {
            //   // const defaultTime = val.set({ hour: 6, minute: 0 }); // Set time to 6:00 AM
            //   formik.values.shiftStartTime = null;
            //   setModalErrorTextEndTime("Shift end time must be between 6:00 AM and 12:00 AM AEST");
            // } else {
            //   formik.values.shiftStartTime = val;
            //   setModalErrorTextEndTime("")
            // }
          }}
          onBlur={formik.handleBlur}
          value={formik.values.shiftEndTime}
          defaultTime={formik.values.shiftEndTime}
          error={!!(formik.touched.shiftEndTime && formik.errors.shiftEndTime)}
          helperText={formik.touched.shiftEndTime && formik.errors.shiftEndTime ? formik.errors.shiftEndTime : ""}
        />
        {modalErrorTextEndTime && modalErrorTextEndTime !== "" && (<Label title={modalErrorTextEndTime} className="small error" />)}
        {formik.errors.shiftEndTime && formik.touched.shiftEndTime ? (
          <Label title="Please select shift start time" className="small error" />) : ("")}
        <p className="w-100 mb-0 gray">Brisbane Time</p>
      </div>

      <div className="col-sm-12 mt-4">
        <ICSelect
          label=""
          id="doctorId"
          name="doctorId"
          placeholder="Select Doctor"
          useId="_id"
          render={val => `Dr ${val.firstName} ${val.lastName}`}
          isCombined={true}
          disabled={true}
          items={props.doctorList}
          handleChange={val => {
            formik.handleChange("doctorId");
            formik.setFieldValue("doctorId", val);
          }}
          onBlur={formik.handleBlur}
          value={formik.values.doctorId}
        />
      </div>

      <div className="col-sm-12 mt-4 row center-align-with-flex">
        {props.dataToEdit && (<Button type="button" title="Delete" className="ic-btn-red  mr-4"
                                      clickEvent={() => props.deleteShift()} />)}
        <Button disabled={!scheduleFilter || !formik.values.doctorId || !formik.values?.shiftDates?.length}
                type="submit" className="insta-button-primary" />
      </div>
      <CustomModal
        title={"Error"}
        useOneButton={true}
        cancelText="OKAY"
        openModal={!!modalErrorText}
        cancelEvent={() => {
          setModalErrorText("");
        }}
        modalBodyContent={`<p className="text-center mb-0">${modalErrorText}</p>`}
      />
    </form>
  </>);
};

export default AddShiftForm;

AddShiftForm.defaultProps = {
  serverErrorMsg: ""
};

AddShiftForm.propTypes = {
  onFormSubmit: PropTypes.func, serverErrorMsg: PropTypes.string
};
